module.exports = __webpack_public_path__ + "static/media/smart-logo.ac910574.png";